package games.polyclub.website.frontend.store.pages.skyfactory

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.website.frontend.store.components.ImageDetails
import games.polyclub.website.frontend.store.components.ImageSelection
import react.Props

val SkyFactoryImages = SFC<Props> { _ ->
    ImageSelection {
        images = listOf(
            ImageDetails("/img/skyfactory/screenshot-main.jpg", "Tela Inicial", "Tela Inicial do Modpack"),
            ImageDetails("/img/skyfactory/screenshot1.png", "Imagem do jogo"),
            ImageDetails("/img/skyfactory/screenshot2.png", "Imagem do jogo"),
            ImageDetails("/img/skyfactory/screenshot3.png", "Imagem do jogo"),
        )
    }
}
